module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Manual Billing")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form')], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.billingTableData.length > 0) ? _c('div', {
    staticClass: "box-header"
  }, [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.showMoreItem
    }
  }, [_vm._v(_vm._s(_vm.showMoreNewItem == false ? "Show Existing Bills" : "New Billing "))])], 1) : _vm._e(), _vm._v(" "), (_vm.billingTableData.length > 0) ? _c('div', {
    staticClass: "box"
  }, [(_vm.showMoreNewItem == true) ? _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "ffContainer"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.No")]), _vm._v(" "), _c('th', [_vm._v("Tally Invoice No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Job Type")]), _vm._v(" "), _c('th', [_vm._v("Tally Status")]), _vm._v(" "), _c('th', [_vm._v("Added In Tally")]), _vm._v(" "), _c('th', [_vm._v("Date & Details")]), _vm._v(" "), _c('th', [_vm._v("PDF")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.billingTableData), function(item1, index) {
    return _c('tr', {
      key: index,
      style: (item1.TallyResponse == '' ? 'color:red' : item1.LINEERROR == '' && item1.CREATED != '0' ? 'color:green ' : 'color:red')
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      style: (item1.TallyResponse == '' ? 'color:red' : item1.LINEERROR == '' && item1.CREATED != '0' ? 'color:green ' : 'color:red'),
      on: {
        "click": function($event) {
          _vm.getBillData(item1)
        }
      }
    }, [_vm._v(_vm._s(item1.BillingSeries))]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item1.clientName) + "\n                        "), _c('br'), _vm._v(" "), (item1.invoiceForClient == '2') ? _c('b-badge', [_vm._v("Overseas Agent")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.jobType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.TallyResponse == '' ? 'Failed To connect to Tally' : item1.LINEERROR == '' && item1.CREATED != '0' ? 'DATA ADDED SUCCESSFULLY IN TALLY ' : item1.LINEERROR))]), _vm._v(" "), _c('td', [_c('md-icon', {
      staticClass: "md-size md-accent",
      style: (item1.TallyResponse == '' ? 'color:red' : item1.LINEERROR == '' && item1.CREATED != '0' ? 'color:green ' : 'color:red')
    }, [_vm._v(_vm._s(item1.TallyResponse == '' ? 'clear' : item1.LINEERROR == '' && item1.CREATED != '0' ? 'done_outline' : 'clear'))])], 1), _vm._v(" "), _c('td', [_vm._v("\n                        On " + _vm._s(item1.loginTime) + "\n                        "), _c('br'), _vm._v("\n                        By " + _vm._s(item1.employeeName) + "\n                        "), _c('br'), _vm._v("\n                        At " + _vm._s(item1.billingLocationName) + "\n                      ")]), _vm._v(" "), _c('td', [(item1.dataPdf) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/TALLY_PDF/" + item1.dataPdf,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View PDF")]) : _vm._e()])])
  }))]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.loadMoreEntry
    }
  }, [_vm._v("Load More Data")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showMoreNewItem == false || _vm.billingTableData.length == 0) ? _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex-small": "100"
    }
  }, _vm._l((_vm.showSegmentArray), function(segmentNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": segmentNameArray.flex,
        "md-flex-small": "100"
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.value,
        "name": 'jobType' + (index + 1),
        "id": 'jobType' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.jobTypeSelect(segmentNameArray.value, index)
        }
      },
      model: {
        value: (_vm.ffInvoiceModal.jobType[index]),
        callback: function($$v) {
          _vm.$set(_vm.ffInvoiceModal.jobType, index, $$v)
        },
        expression: "ffInvoiceModal.jobType[index]"
      }
    }, [_c('b', [_vm._v(_vm._s(segmentNameArray.show))])])], 1)
  }))], 1)], 1), _vm._v(" "), _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientData,
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select "
    },
    on: {
      "input": _vm.changeClient
    },
    model: {
      value: (_vm.ffInvoiceModal.clientId),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "clientId", $$v)
      },
      expression: "ffInvoiceModal.clientId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.pridelBranch,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select "
    },
    on: {
      "input": _vm.changJob
    },
    model: {
      value: (_vm.ffInvoiceModal.pickupId),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "pickupId", $$v)
      },
      expression: "ffInvoiceModal.pickupId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Billing Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.billingLocationData,
      "option-value": "billingLocationId",
      "option-text": "billingLocation",
      "placeholder": "Select Billing Location"
    },
    on: {
      "input": _vm.getBillingBranch
    },
    model: {
      value: (_vm.ffInvoiceModal.billingLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "billingLocationId", $$v)
      },
      expression: "ffInvoiceModal.billingLocationId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Contact")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.contact),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "contact", $$v)
      },
      expression: "ffInvoiceModal.contact"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client GSTN")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.clientgst),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "clientgst", $$v)
      },
      expression: "ffInvoiceModal.clientgst"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.stateName),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "stateName", $$v)
      },
      expression: "ffInvoiceModal.stateName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.adress),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "adress", $$v)
      },
      expression: "ffInvoiceModal.adress"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Pickup Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.pickup),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "pickup", $$v)
      },
      expression: "ffInvoiceModal.pickup"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Handover Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.Handover),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "Handover", $$v)
      },
      expression: "ffInvoiceModal.Handover"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Factory Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.factoryLoc),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "factoryLoc", $$v)
      },
      expression: "ffInvoiceModal.factoryLoc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place Of Receipt")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.POR),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "POR", $$v)
      },
      expression: "ffInvoiceModal.POR"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Load Port")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.LP),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "LP", $$v)
      },
      expression: "ffInvoiceModal.LP"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port Of Discharge")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.POD),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "POD", $$v)
      },
      expression: "ffInvoiceModal.POD"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Place of Delivery")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.FPOD),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "FPOD", $$v)
      },
      expression: "ffInvoiceModal.FPOD"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Bill No/ Date")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.BOE),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "BOE", $$v)
      },
      expression: "ffInvoiceModal.BOE"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("BL No")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.blNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "blNo", $$v)
      },
      expression: "ffInvoiceModal.blNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice No.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.shipperInvNoforTally),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shipperInvNoforTally", $$v)
      },
      expression: "ffInvoiceModal.shipperInvNoforTally"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice Date")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.shipperInvDateforTally),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shipperInvDateforTally", $$v)
      },
      expression: "ffInvoiceModal.shipperInvDateforTally"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.vessel),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "vessel", $$v)
      },
      expression: "ffInvoiceModal.vessel"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Weight (KGS)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.weight),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "weight", $$v)
      },
      expression: "ffInvoiceModal.weight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Line Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shippingLine", $$v)
      },
      expression: "ffInvoiceModal.shippingLine"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.ffInvoiceModal.billingId != '' && _vm.ffInvoiceModal.containerDetails != '') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Freight Container No.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.containerDetails),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "containerDetails", $$v)
      },
      expression: "ffInvoiceModal.containerDetails"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Freight Container Type")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.multipleContainerType),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "multipleContainerType", $$v)
      },
      expression: "ffInvoiceModal.multipleContainerType"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_vm._l((_vm.containerDetailsManual), function(item, index) {
    return _c('md-layout', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "md-gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "50"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('label', [_vm._v("Container No.")]), _vm._v(" "), _c('b-form-textarea', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "clientRegistrationNo",
        "name": "clientRegistrationNo"
      },
      model: {
        value: (item.containerNoFF),
        callback: function($$v) {
          _vm.$set(item, "containerNoFF", $$v)
        },
        expression: "item.containerNoFF"
      }
    })], 1)], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "45"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('b-form-textarea', {
      staticClass: "gutr",
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "clientRegistrationNo",
        "name": "clientRegistrationNo"
      },
      model: {
        value: (item.containerTypeFF),
        callback: function($$v) {
          _vm.$set(item, "containerTypeFF", $$v)
        },
        expression: "item.containerTypeFF"
      }
    })], 1)], 1)], 1)
  }), _vm._v(" "), (_vm.ffInvoiceModal.containerDetailsCC.length > 0 && _vm.ffInvoiceModal.billingId == '') ? _c('b-container', {
    staticClass: "gutr"
  }, [_c('b-card', {
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_c('u', [_vm._v("Custom Container Details")])])])], 1), _vm._v(" "), _vm._l((_vm.ffInvoiceModal.containerDetailsCC), function(item, index) {
    return _c('md-layout', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "md-gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "50"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('label', [_vm._v("Container No.")]), _vm._v(" "), _c('b-form-textarea', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": "",
        "id": "clientRegistrationNo",
        "name": "clientRegistrationNo",
        "value": item.containerNoFF
      }
    })], 1)], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "40"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('b-form-textarea', {
      staticClass: "gutr",
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": "",
        "id": "clientRegistrationNo",
        "name": "clientRegistrationNo",
        "value": item.containerTypeFF
      }
    })], 1)], 1)], 1)
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.TPTGRNDATA.length > 0) ? _c('b-card', {
    staticClass: "mt-3",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('div', {
    staticClass: "box gutr"
  }, [_c('div', {
    staticClass: "box-body gutr"
  }, [_c('h5', [_c('b-badge', [_vm._v("TPT Annexure Details")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-striped gutr",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("GRN Number")]), _vm._v(" "), _c('th', [_vm._v("Container Number & Type")]), _vm._v(" "), _c('th', [_vm._v("Fuel Slip No.")]), _vm._v(" "), _c('th', [_vm._v("Vehicle No")]), _vm._v(" "), _c('th', [_vm._v("S-Line Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.TPTGRNDATA), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n                                    " + _vm._s(item.GRNSeries) + "\n                                    "), _c('br'), _vm._v(" "), (item.billingToTallDone == 1) ? _c('b-button', {
      attrs: {
        "disabled": "",
        "variant": "warning",
        "size": "sm"
      }
    }, [_vm._v("Billing Done")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (item.invoiceStatus != 0) ? _c('b-button', {
      attrs: {
        "disabled": "",
        "variant": "warning",
        "size": "sm"
      }
    }, [_vm._v("Invoice Pending From TPT")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "info",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeGRN(index, item)
        }
      }
    }, [_vm._v("Remove")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(item.containerNo) + "\n                                    "), _c('br'), _vm._v("\n                                    " + _vm._s(item.multipleContainerType) + "\n                                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.FuelSlipNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vehicleNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.slineSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.customSealNo))]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Loading Date :" + _vm._s(_vm._f("moment")(item.Date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Reporting Date :" + _vm._s(_vm._f("moment")(item.factoryInDate)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Released Date :" + _vm._s(_vm._f("moment")(item.factoryOutDate)))])])])
  }))])])])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Other Charges Freight")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.otherChargeFF),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "otherChargeFF", $$v)
      },
      expression: "ffInvoiceModal.otherChargeFF"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()])], 1), _vm._v(" "), (_vm.showMoreNewItem == false || _vm.ffInvoiceModal.billingId != '' || _vm.billingTableData.length == 0) ? _c('div', {
    staticClass: "mt-2"
  }, [(_vm.ffInvoiceModal.billingId != '') ? _c('b-form-checkbox', {
    attrs: {
      "size": "lg",
      "value": "notSelected"
    },
    on: {
      "change": _vm.copyCharges
    },
    model: {
      value: (_vm.selectedTallyInv),
      callback: function($$v) {
        _vm.selectedTallyInv = $$v
      },
      expression: "selectedTallyInv"
    }
  }, [_vm._v("Select to Update Charges Details")]) : _vm._e(), _vm._v(" "), _c('div', [_c('h5', [_c('b-badge', [_vm._v("CHARGES")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table  mt-3 table-light  table-bordered",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "45px"
    }
  }, [(_vm.ffInvoiceModal.billingId == '') ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.addQuotationFields
    }
  }, [_c('md-icon', {
    attrs: {
      "md-va": ""
    }
  }, [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "input": _vm.SelectedAll
    },
    model: {
      value: (_vm.slectedAllStatus),
      callback: function($$v) {
        _vm.slectedAllStatus = $$v
      },
      expression: "slectedAllStatus"
    }
  })], 1), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "350px"
    }
  }, [_c('span', [_vm._v("Particulars *")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Container Type")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Quantity *")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Currency *")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Selling Rate *")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Exch Rate *")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Final Amount *")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Unit *")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Remarks")])])]), _vm._v(" "), _vm._l((_vm.ffTallyInvoiceData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('b-form-checkbox', {
      attrs: {
        "value": "1",
        "unchecked-value": "0"
      },
      model: {
        value: (item.slectedStatus),
        callback: function($$v) {
          _vm.$set(item, "slectedStatus", $$v)
        },
        expression: "item.slectedStatus"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.ledgerData,
        "option-value": "ledger",
        "option-text": "ledger"
      },
      on: {
        "input": function($event) {
          _vm.getDuplicateLedger(item)
        }
      },
      model: {
        value: (item.ffType),
        callback: function($$v) {
          _vm.$set(item, "ffType", $$v)
        },
        expression: "item.ffType"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.containerMasterData,
        "option-value": "containerType",
        "option-text": "containerType"
      },
      model: {
        value: (item.containerType),
        callback: function($$v) {
          _vm.$set(item, "containerType", $$v)
        },
        expression: "item.containerType"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.quantity),
        callback: function($$v) {
          _vm.$set(item, "quantity", $$v)
        },
        expression: "item.quantity"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.currencyList,
        "option-value": "currencyV",
        "option-text": "currencyT"
      },
      model: {
        value: (item.currency),
        callback: function($$v) {
          _vm.$set(item, "currency", $$v)
        },
        expression: "item.currency"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.sellingRateFinal),
        callback: function($$v) {
          _vm.$set(item, "sellingRateFinal", $$v)
        },
        expression: "item.sellingRateFinal"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.exchRate),
        callback: function($$v) {
          _vm.$set(item, "exchRate", $$v)
        },
        expression: "item.exchRate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      model: {
        value: (item.invAmount),
        callback: function($$v) {
          _vm.$set(item, "invAmount", $$v)
        },
        expression: "item.invAmount"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.unitList,
        "option-value": "unitId",
        "option-text": "unitName"
      },
      model: {
        value: (item.unit),
        callback: function($$v) {
          _vm.$set(item, "unit", $$v)
        },
        expression: "item.unit"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.remark),
        callback: function($$v) {
          _vm.$set(item, "remark", $$v)
        },
        expression: "item.remark"
      }
    })], 1)])
  })], 2)])]), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per gutr mt-5",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [(_vm.validateTally == false && _vm.ffInvoiceModal.billingId == '') ? _c('b-button', {
    attrs: {
      "block": "",
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addDataTally
    }
  }, [_vm._v(_vm._s(_vm.ffInvoiceModal.billingId != '' ? 'Update' : 'Send Data To Tally'))]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopMaxPer",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.confirm.contentHtml,
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.sendMail
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopTally",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.submitInvoice
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d75a33e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/manualTallyBilling.vue
// module id = 2388
// module chunks = 0